// Mirrors the ReScript Catalyst.Loadable runtime shape that still backs
// order_history until it is provided by a TS AuthProvider.
const LIVE_TAG = 1;
const COURIER_TYPE = 3;

interface RescriptOrder {
  order_crn: string;
  _type: number;
}

interface RescriptLoadableLive {
  TAG: number;
  _0: RescriptOrder[];
}

function liveOrders(history: unknown): RescriptOrder[] | null {
  if (typeof history !== 'object' || history === null) {
    return null;
  }
  const loadable = history as Partial<RescriptLoadableLive>;
  return loadable.TAG === LIVE_TAG && Array.isArray(loadable._0)
    ? loadable._0
    : null;
}

export function countOfLiveOrder(history: unknown): number {
  const orders = liveOrders(history);
  return orders ? orders.length : 0;
}

export function orderCrn(history: unknown, index: number): string {
  const orders = liveOrders(history);
  return orders && orders.length > 0 ? orders[index].order_crn : '';
}

export function isCourierOrder(history: unknown, index: number): boolean {
  const orders = liveOrders(history);
  return !!orders && orders.length > 0 && orders[index]._type === COURIER_TYPE;
}
